<template>
  <div class="box animated fadeIn">
    <div class="outline">
      <div style="height: 100%;position: relative;">
        <div class="rightCon" :style="{ width: '60%', marginLeft: '40%' }">
          <div class="HeaderTitle">
            <div>{{ Container.title }}</div>
          </div>
          <p class="text" v-html="Container.text"></p>

          <h1
            v-if="Container.listtitle"
            class="title"
            style="padding-top:20px"
            v-html="Container.listtitle"
          ></h1>

          <div v-if="Container.plainlist">
            <p
              v-for="item in Container.list"
              class="text"
              v-html="item.body"
            ></p>
          </div>

          <ul v-else style="margin-left:20px">
            <li v-for="item in Container.list" style="font-size: 2rem">
              <!--<div class="dvline"></div>-->

              <p
                v-if="item.body.constructor !== Array"
                class="text"
                v-html="item.body"
              ></p>
            </li>
          </ul>

          <h1
            v-if="Container.endtitle"
            class="title"
            style="padding-top:20px"
            v-html="Container.endtitle"
          ></h1>
        </div>

        <div class="leftCon" :style="{ width: '40%' }">
          <div class="img" :style="Covers"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Media from "@dongido/vue-viaudio";
export default {
  name: "HelloWorld",
  components: { Media },
  props: {
    Type: Boolean,
    ImgUrl: String,
    ImgUrls: String,
    Container: Object
  },
  data() {
    return {
      Cover: {
        backgroundImage: "url(" + require("../assets/" + this.ImgUrl) + ")"
      },
      Covers: {
        backgroundImage: "url(" + require("../assets/" + this.ImgUrls) + ")"
      }
    };
  },
  mounted() {},

  methods: {
    goBack() {
      this.$router.push("/Home");
    },
    PlayEvent() {
      this.$refs.Player.play();
    },
    PauseEvent() {
      this.$refs.Player.pause();
    },
    SwitchGO() {
      this.Switch = !this.Switch;
    }
  }
};
</script>

<style scoped lang="scss">
.subtitle {
  font-size: 1.5rem;
}
.HeaderTitle {
  line-height: 3rem;
  display: flex;
  justify-content: space-between;
  font-size: 2rem;
  border-bottom: 1px solid #fff;
  margin-bottom: 30px;
  padding-bottom: 20px;
}

.switchbtn1 {
  margin-top: 30px;
  text-align: center;
  border-radius: 30px;
  border: 1px solid #fff;
  line-height: 50px;
  font-size: 1.5rem;
  color: #fff;
  width: 400px;
  height: 50px;
}
.switchbtn2 {
  margin-top: 30px;
  text-align: center;
  border-radius: 30px;
  border: 1px solid #fff;
  line-height: 50px;
  font-size: 1.5rem;
  color: #fff;
  width: 200px;
  height: 50px;
}
.dvline {
  height: 1px;
  background-color: aliceblue;
  margin: 20px;
}
.title {
  font-size: 1.6rem;
}
.text {
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  font-size: 1.2rem;
  line-height: 2rem;
  font-weight: 400;
  text-align: justify;
}

.img {
  width: 100%;
  height: 100%;
  /*position: relative;*/
  background-color: #999999;
  /*background-size: 100%;*/
}

.leftCon {
  width: 63%;
  height: 100%;
}

.rightCon {
  color: #fff;
  text-align: left;
  padding: 60px;
  float: right;
  width: 37%;
  height: 100%;
  background-color: #555555;
}

.outline {
  /*background-color: blueviolet;*/
  height: 100%;
}

.box {
  /*position: absolute;*/
  /*background-color: black;*/
  padding: 120px 60px 50px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  height: 100%;
}

.videos {
  width: 100%;
  height: 100%;
  background-color: black;
}
</style>
